import React from "react";
import AreaListagem from "./components/listagem/AreaListagem";
import { useConfigureFooter } from "~hooks/useHelpers";

const Simulators = () => {
  useConfigureFooter({ notDeveloped: false });

  return (
    <>
      <div className="bg-terciaria full-screen-width">
        <div className="flex space-x-4 p-4 text-white container">
          <div className="w-full">
            <p className="font-bold text-lg text-center py-3">
              Últimas Simulações
            </p>
          </div>
        </div>
      </div>

      <AreaListagem />
    </>
  );
};

export default Simulators;
